export function buildBookingWhatsAppUrl({ whatsappNumber, language, booking, serviceText }) {
  const cleanNumber = String(whatsappNumber || '').replace(/\D/g, '');
  const serviceTitle = serviceText?.title || booking.serviceId;

  const messageDe = `Hallo Hakuna Matata,

ich möchte gerne einen Termin anfragen:

Service: ${serviceTitle}
Datum: ${booking.date}
Uhrzeit: ${booking.time}

Name: ${booking.name}
Telefon: ${booking.phone}
E-Mail: ${booking.email || '-'}

Hinweis:
${booking.note || '-'}

Bitte um Bestätigung. Danke!`;

  const messageEn = `Hello Hakuna Matata,

I would like to request an appointment:

Service: ${serviceTitle}
Date: ${booking.date}
Time: ${booking.time}

Name: ${booking.name}
Phone: ${booking.phone}
Email: ${booking.email || '-'}

Note:
${booking.note || '-'}

Please confirm. Thank you!`;

  const text = language === 'en' ? messageEn : messageDe;

  return `https://wa.me/${cleanNumber}?text=${encodeURIComponent(text)}`;
}

export function buildSimpleWhatsAppUrl({ whatsappNumber, message }) {
  const cleanNumber = String(whatsappNumber || '').replace(/\D/g, '');
  return `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message || '')}`;
}
